$(() => {
  var swiperTestimonial = new Swiper(".swiper-testimonial", {
    slidesPerView: 1,
    spaceBetween: 15,
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    // slidesPerView: '1',
    // centeredSlides: true,
    freeMode: true,
    // pagination: {
    //   el: ".testimonial-pagination",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".testimonial-next",
      prevEl: ".testimonial-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        // slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });

  var swiperTestimonialCentered = new Swiper(".swiper-testimonial--centered", {
    slidesPerView: 1,
    spaceBetween: 15,
    // slidesPerView: '1',
    // centeredSlides: true,
    pagination: {
      el: ".testimonial-pagination",
      clickable: true,
      type: 'fraction'
    },
    navigation: {
      nextEl: ".testimonial-centered-next",
      prevEl: ".testimonial-centered-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        // slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });

  var swiperBanner = new Swiper(".swiper-banner", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    
    // effect: "fade",
    // creativeEffect: {
    //   prev: {
    //     shadow: true,
    //     translate: ["-120%", 0, -500],
    //   },
    //   next: {
    //     shadow: true,
    //     translate: ["120%", 0, -500],
    //   },
    // },
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
  });

  var swiperIcons = new Swiper(".swiper-icons", {
    slidesPerView: 1,
    spaceBetween: 15,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: ".btn-icon-next",
      prevEl: ".btn-icon-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  /* Creating a new Swiper instance. */
  var swiperRichtext1 = new Swiper(".swiper-richtext--1", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination-richtext--1",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  /* Creating a new Swiper instance. */
  var swiperRichtext1 = new Swiper(".swiper-richtext--2", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination-richtext--2",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var swiperTimelineThumbs = new Swiper(".swiper-timeline--thumbs", {
    spaceBetween: 10,
    // slidesPerView: 'auto',
    slidesPerView: 1,
    // freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 5,
      },
    },
  });

  swiperTimelineThumbs.on('slideChange', function () {
    const activeIndex = swiperTimelineThumbs.activeIndex;
    swiperTimeline.slideTo(activeIndex);
  });
  

  var swiperTimeline = new Swiper(".swiper-timeline", {
    spaceBetween: 10,
    slidesPerView: 1,
    thumbs: {
      swiper: swiperTimelineThumbs,
    },
  });

  var swiperCollectionThumbs = new Swiper(".swiper-collection--thumbs", {
    spaceBetween: 10,
    slidesPerView: 'auto',
    // slidesPerView: 1,
    // freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    // multipleActiveThumbs: false,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 60,
      },
      992: {
        slidesPerView: 'auto',
        spaceBetween: 100,
      },
    },
  });

  var swiperCollection = new Swiper(".swiper-collection", {
    spaceBetween: 10,
    slidesPerView: 1,
    thumbs: {
      swiper: swiperCollectionThumbs,
    },
  });

  var swiperProjectsBanner = new Swiper(".swiper-projects--banner", {
    pagination: {
      el: ".swiper-pagination",
    //   dynamicBullets: true,
    },
  });

  var swiperBlogBanner = new Swiper(".swiper-blog--banner", {
    pagination: {
      el: ".swiper-pagination",
    //   dynamicBullets: true,
    },
  });

  var swiperPartners = new Swiper(".swiper-partners", {
    pagination: {
      el: ".swiper-pagination",
    //   dynamicBullets: true,
    },
    navigation: {
      nextEl: ".next-partner",
      prevEl: ".prev-partner",
    },
  });

  var swiperArtist = new Swiper(".swiper-artist", {
    
    slidesPerView: 1,
    spaceBetween: 30,
    centerInsufficientSlides: true,
    pagination: {
      el: ".swiper-pagination",
    //   dynamicBullets: true,
    },
    navigation: {
      nextEl: ".next-artist",
      prevEl: ".prev-artist",
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
      },
    },
  });

  var swiperCollectionCarousel = new Swiper(".swiper-collection--carousel", {
    
    slidesPerView: 1,
    // spaceBetween: 30,
    centeredSlides: true,
    // centerInsufficientSlides: true,
    pagination: {
      el: ".swiper-pagination",
    //   dynamicBullets: true,
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        initialSlide: 1

      },
    },
  });

  //   var swiperTimeline = new Swiper(".swiper-timeline", {
  //     slidesPerView: 1,
  //     slidesPerGroupSkip: 1,
  //     grabCursor: true,
  //     keyboard: {
  //       enabled: true,
  //     },
  //     pagination: {
  //       el: ".pagination-timeline",
  //       dynamicBullets: true,
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       768: {
  //         slidesPerView: 2,
  //         slidesPerGroup: 2,
  //       },
  //       992: {
  //         slidesPerView: 3,
  //         slidesPerGroup: 3,
  //       },
  //     },
  //   });
});
